import { useEffect, useState } from 'react';
import type { HealthStatus } from '../types';
import { createLogger } from '../../utils/logger';
import { mobileFetch } from '../api';

const log = createLogger('useMobileHealth');

export interface HealthState {
  health: HealthStatus | null;
  beLive: boolean;
  dbLive: boolean;
  refresh: () => Promise<void>;
}

const POLL_INTERVAL_MS = 5000;

export function useMobileHealth(): HealthState {
  const [health, setHealth] = useState<HealthStatus | null>(null);
  const [beLive, setBeLive] = useState(false);
  const [dbLive, setDbLive] = useState(false);

  const fetchHealth = async () => {
    try {
      const response = await mobileFetch('/health');
      if (response.ok) {
        const data: HealthStatus = await response.json();
        setHealth(data);
        setBeLive(true);
        setDbLive(true);
      } else {
        // Server responded with an error: BE is up but the DB-backed handler failed.
        log.warn(`Health returned non-OK status ${response.status}`);
        setBeLive(true);
        setDbLive(false);
      }
    } catch (error) {
      // Network error / no response / session expired: cannot confirm BE or DB.
      log.warn('Failed to fetch health:', error);
      setBeLive(false);
      setDbLive(false);
    }
  };

  useEffect(() => {
    fetchHealth();
    const interval = setInterval(fetchHealth, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return { health, beLive, dbLive, refresh: fetchHealth };
}
